<template>
    <Banner>
        <LearningPathBannerDescription
            :description="learningPath.description"
            :title="learningPath.title"
            :learningPathId="learningPath.id"
            :categories="learningPath.categories"
            :levels="learningPath.levels"
            :publishDate="learningPath.publishDate"
            :expirationDate="learningPath.expirationDate"
            :lastUpdatedDate="learningPath.checkedAt"
            :progressPercentage="learningPath.percentageCompleted"
            :isSubscribed="learningPath.subscribed"
            :isLearningPathCompleted="isLearningPathCompleted"
            :hasAccessToLearningPath="hasAccessToLearningPath"
        >
        </LearningPathBannerDescription>

        <LearningPathBannerDetails
            :duration="duration"
            :amountOfCourses="courses.length"
            :showFinishProgress="showFinishProgress"
            :authorizationPoints="learningPath.authorizationPoints"
            :recommendedPace="learningPath.learningPace"
        >
        </LearningPathBannerDetails>
    </Banner>
</template>

<script>
    import Banner from 'components/layout/Banner'
    import LearningPathBannerDescription from 'components/learningpathpage/banner/LearningPathBannerDescription'
    import LearningPathBannerDetails from 'components/learningpathpage/banner/LearningPathBannerDetails'
    import { mapGetters } from 'vuex'

    export default {
        name: 'LearningPathBanner',
        components: {
            Banner,
            LearningPathBannerDescription,
            LearningPathBannerDetails
        },
        props: {
            learningPath: Object,
            courses: Array,
            finishProgress: {
                type: Number,
                default: 0
            },
            showFinishProgress: {
                type: Boolean,
                default: false
            },
            duration: Number,
            hasAccessToLearningPath: Boolean
        },
        computed: {
            ...mapGetters({
                isCourseCompleted: 'CompletedCourses/isCourseCompleted',
                videoLogForCourse: 'VideoLog/getVideoLogWithCourseId'
            }),
            learningPathTotalProgress () {
                let videoLogs = this.courses.map(course => this.videoLogForCourse(course.id))
                if (!videoLogs.length) return 0
                const totalWatched = videoLogs.reduce((total, videoLog) => {
                    if (!videoLog) return total
                    return total + videoLog.total_watched
                }, 0)
                return (totalWatched / 60) / this.duration * 100
            },
            isLearningPathCompleted () {
                return this.learningPath.hasUserCertificate || this.learningPath.canUserCreateCertificate
            }
        }
    }
</script>
